<template>
  <div class="container mescroll-touch">
    <div class="goPersonal" @click="toLiveHome">
      <img src="../../assets/images/icon_left1.png" />
      <span>星光</span>
    </div>
    <div class="userInfoBox">
      <div class="userInfo">
        <div class="touxiang">
          <img src="@/assets/images/headSculpture1.png" alt="" />
        </div>
        <div class="info">
          <p class="name">{{ userDetails.UserName }}</p>
          <p class="positionalName">{{ userDetails.PositionalName }}</p>
        </div>
      </div>
      <div class="hospital">
        <img src="@/assets/images/hospital@2x.png" alt="" />
        <span>{{ userDetails.HospitalTitle }}</span>
      </div>
      <div class="hospital">
        <img src="@/assets/images/keshi@2x.png" alt="" />
        <span>{{ userDetails.SubjectName }}</span>
      </div>
      <div class="dataBox">
        <div class="dataItem" @click="toFansFollowList('followers')">
          <span class="dataNum">{{ userDetails.FansCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">粉丝</span>
          <span class="dataName" v-if="userInfo.Type == 3">Followers</span>
        </div>
        <div class="dataItem" @click="toFansFollowList('following')">
          <span class="dataNum">{{ userDetails.AttentionCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">关注</span>
          <span class="dataName" v-if="userInfo.Type == 3">Following</span>
        </div>
        <div class="dataItem" @click="showFavorites">
          <span class="dataNum">{{ userDetails.LikeAndCollectCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">获赞与收藏</span>
          <span class="dataName" v-if="userInfo.Type == 3">Favorites</span>
        </div>
      </div>
      <template v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
        <div class="shareBox" v-if="userInfo.Type != 3">
          <img class="shareIcon" src="@/assets/images/share.png" alt="" @click="toPersonalPoster" />
          <span>分享名片</span>
        </div>
        <div class="customerServiceBox" :class="{'customerServiceBox_en' : userInfo.Type == 3}">
          <img class="customerServiceIcon" src="@/assets/images/customerService.png" alt="" @click="CustomerServicePopup = true" />
          <span v-if="userInfo.Type != 3">联系客服</span>
          <span v-if="userInfo.Type == 3">Help Center</span>
        </div>
      </template>
      <template v-else>
        <div class="followBtn follow" v-if="followState == 0" @click="follow">
          <van-icon class="plusIcon" name="plus" />
          <span v-if="userInfo.Type != 3">关注</span>
          <span v-if="userInfo.Type == 3">Follow</span>
        </div>
        <div class="followBtn unfollow" v-else @click="unFollow">
          <span v-if="userInfo.Type != 3">取消关注</span>
          <span v-if="userInfo.Type == 3">Unfollow</span>
        </div>
      </template>
    </div>
    <div class="menuBox" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
      <div class="menuItem" @click="toMyFavorite">
        <img src="@/assets/images/mydz@2x.png" alt="" />
        <span v-if="userInfo.Type != 3">我的点赞</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Likes</span>
      </div>
      <div class="menuItem" @click="toMyCollection">
        <img src="@/assets/images/mysc@2x.png" alt="" />
        <span v-if="userInfo.Type != 3">我的收藏</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Favorites</span>
      </div>
      <div class="menuItem" @click="toMyMeeting">
        <img src="@/assets/images/myhy@2x.png" alt="" />
        <span v-if="userInfo.Type != 3">我的预约</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Events</span>
      </div>
      <div class="menuItem" @click="toBrowseRecords">
        <img src="@/assets/images/myjl@2x.png" alt="" />
        <span v-if="userInfo.Type != 3">历史记录</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">View History</span>
      </div>
    </div>
    <div class="contentBox" v-if="liveDetailes != null && Object.keys(liveDetailes).length > 0">
      <div class="contentTitle">
        <img class="contentTitle_icon1" src="@/assets/images/personal_live.png" alt="" />
        <span v-if="userInfo.Type != 3">专属活动区</span>
        <span v-if="userInfo.Type == 3">Live Room</span>
      </div>
      <div class="liveBox" @click="toLive(liveDetailes.url)">
        <div class="liveCoverBox">
          <img class="liveCover" :src="liveDetailes.cover" alt="" />
          <img class="playIcon" src="../../assets/images/play_icon.png" />
          <div class="liveStatus" v-if="liveDetailes.event_type == 1">进行中</div>
        </div>
        <p class="liveTitle van-multi-ellipsis--l2">{{ liveDetailes.title }}</p>
      </div>
    </div>
    <div class="contentBox">
      <div class="contentTitle">
        <img class="contentTitle_icon2" src="@/assets/images/personal_content.png" alt="" />
        <span v-if="userInfo.Type != 3">内容</span>
        <span v-if="userInfo.Type == 3">Content</span>
      </div>
      <div class="articleList" v-if="articleList.length > 0">
        <div class="articleItem" v-for="(item, index) in articleList" :key="index" @click="toContentPage(item.Id, item.Type)">
          <div class="articleCover">
            <img :src="item.Thumbnail" alt="" />
            <div class="sourceTag" v-if="item.SourceContent && item.SourceLink">{{ item.SourceContent }}</div>
          </div>
          <div class="articleInfo">
            <p class="articleTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
            <div class="articleData">
              <div class="operateBox">
                <div class="operateItem">
                  <img class="operateIcon watch" src="@/assets/images/personal_watch_active.png" alt="" />
                  <span>{{ item.WatchCount }}</span>
                </div>
                <div class="operateItem">
                  <img class="operateIcon like" src="@/assets/images/personal_like_active.png" alt="" />
                  <span>{{ item.LikeCount }}</span>
                </div>
                <div class="operateItem">
                  <img class="operateIcon collect" src="@/assets/images/personal_collect_active.png" alt="" />
                  <span>{{ item.CollectCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="notContent" v-else>
        <div class="notContent_btn" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id" @click="CustomerServicePopup = true">
          <template v-if="userInfo.Type != 3">我要投稿</template>
          <template v-if="userInfo.Type == 3">Submit</template>
        </div>
        <span class="text" v-else>
          <template v-if="userInfo.Type != 3">未投稿</template>
          <template v-if="userInfo.Type == 3">No content available</template>
        </span>
      </div>
    </div>
    <div class="contentBox" v-if="liveDetailes == null">
      <div class="contentTitle">
        <img class="contentTitle_icon1" src="@/assets/images/personal_live.png" alt="" />
        <span v-if="userInfo.Type != 3">专属活动区</span>
        <span v-if="userInfo.Type == 3">Live Room</span>
      </div>
      <div class="notContent">
        <span class="text" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
          <template v-if="userInfo.Type != 3">如您需要开展活动，请右上角联系客服</template>
          <template v-if="userInfo.Type == 3"></template>
        </span>
        <span class="text" v-else>
          <template v-if="userInfo.Type != 3">未开播</template>
          <template v-if="userInfo.Type == 3">No content available</template>
        </span>
      </div>
    </div>
    <div class="column" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id" @click="$router.push('/xgPrivacyPolicy')">
      <span v-if="userInfo.Type != 3">隐私声明</span>
      <span v-if="userInfo.Type == 3">Privacy Policy</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
    <template v-if="userInfo.Type != 3">
      <div class="contactUs" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">如果您有学术内容需要上传，欢迎点击<span @click="CustomerServicePopup = true">[联系方式]</span>，<br/>我们将为您提供专业的服务</div>
      <div class="unsubscribe" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id"><span @click="LogoutPopup = true">[注销账户]</span></div>
    </template>
    <template v-if="userInfo.Type == 3">
      <!-- <div class="contactUs" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">Contact us<span @click="CustomerServicePopup = true">[Email]</span></div> -->
      <div class="unsubscribe" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id"><span @click="LogoutPopup = true">[Logout]</span></div>
    </template>
    <van-popup class="FavoritesPopup" v-model="FavoritesPopup" :close-on-click-overlay="true">
      <div class="FavoritesBox">
        <template v-if="userInfo.Type != 3">
          <div class="FavoritesTitle">获赞与收藏</div>
          <div class="FavoritesContent">
            <div class="FavoritesItem">
              <img src="@/assets/images/myArticle.png" alt="" />
              <span class="title">当前发布内容数</span>
              <span class="num">{{ ArtCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myLike.png" alt="" />
              <span class="title">当前获得点赞数</span>
              <span class="num">{{ LikeCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myCollect.png" alt="" />
              <span class="title">当前获得收藏数</span>
              <span class="num">{{ CollectCount }}</span>
            </div>
            <div class="FavoritesConfirm" @click="FavoritesPopup = false">我知道了</div>
          </div>
        </template>
        <template v-else>
          <div class="FavoritesTitle">Likes and Favorites</div>
          <div class="FavoritesContent">
            <div class="FavoritesItem">
              <img src="@/assets/images/myArticle.png" alt="" />
              <span class="enTitle">Current Published Content</span>
              <span class="num">{{ ArtCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myLike.png" alt="" />
              <span class="enTitle">Current Likes Received</span>
              <span class="num">{{ LikeCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myCollect.png" alt="" />
              <span class="enTitle">Current Favorites Collected</span>
              <span class="num">{{ CollectCount }}</span>
            </div>
            <div class="FavoritesConfirm" @click="FavoritesPopup = false">OK</div>
          </div>
        </template>
      </div>
    </van-popup>
    <van-popup class="CustomerServicePopup" v-model="CustomerServicePopup" :close-on-click-overlay="false">
      <div class="close" @click="CustomerServicePopup = false">
        <van-icon class="closeIcon" name="cross" />
      </div>
      <div class="customerServiceQRcode">
        <template v-if="userInfo.Type != 3">
          <span>调整个人信息与投稿或开播等问题</span><br/>
          <span>请长按扫码联系客服</span>
        </template>
         <template v-else>
          <span>To Update Personal Information,</span><br/>
          <span>Submit Content, or Access Live Surgery,</span><br/>
          <span>Please long-press to scan the QR code and</span><br/>
          <span>contact customer service team.</span>
        </template>
        <div class="QRcodeBox">
          <div class="QRcode">
            <img src="@/assets/images/contactSupport.jpg" alt="" />
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup class="LogoutPopup" v-model="LogoutPopup" :close-on-click-overlay="false">
      <div class="close" @click="LogoutPopup = false">
        <van-icon class="closeIcon" name="cross" />
      </div>
      <template v-if="userInfo.Type != 3">
        <img class="warningIcon" src="@/assets/images/warning.png" alt="" />
        <span v-html="'是否确认<注销>'"></span><br/>
        <span style="font-weight: bold;">将删除所有用户记录，无法恢复。</span><br/>
        <span>如确认注销，请复制以下网址在浏览器这打开:</span><br/>
        <span>https://privacyportal.onetrust.com/webform/<br/>96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo</span>
      </template>
      <template v-else>
        <img class="warningIcon" src="@/assets/images/warning.png" alt="" />
        <span class="enLogoutTips">Confirm Account Deletion?</span><br/>
        <span class="enLogoutTips" style="font-weight: bold;">All user data will be permanently deleted and <br/>cannot be recovered.</span><br/>
        <span class="enLogoutTips">Please copy this URL to your browser:</span><br/>
        <span class="enLogoutTips">https://privacyportal.onetrust.com/webform/<br/>96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo</span>
      </template>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from "../../common/mixin/mixins";
import { mapState, mapActions } from "vuex";
export default {
  name: 'JNJUserMain',
  data() {
    return {
      userDetails: {},
      OthersInfo: {},
      followState: 0,
      FavoritesPopup: false,
      ArtCount: 0,
      CollectCount: 0,
      LikeCount: 0,
      CustomerServicePopup: false,
      LogoutPopup: false,
      articleList: [],
      liveDetailes: {}
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
      this.$axios.post('/Api/Api/Web/Customer/GetCustmAll', {
        uid: this.$route.query.otherId
      }).then(res => {
        let data = res.Data;
        this.OthersInfo = data;
        this.getMyInfo();

        if(data.Id != this.userInfo.Id) {
          this.getOthersInfo(data.Id);
          this.getFollowState();
          this.getLive(data.Id);
          this.getArticleList(data.Id);
          this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', data.Id, this.$route.query.sourceType ? this.$route.query.sourceType : '');
        } else {
          this.getLive(this.userInfo.Id); 
          this.getArticleList(this.userInfo.Id);
          this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
        }
      })
    } else {
      this.getJJMTUserId(this.userInfo.Id);
      this.getMyInfo();
      this.getLive(this.userInfo.Id); 
      this.getArticleList(this.userInfo.Id);
      this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    }
    
    this.$store.commit("changeNavbarIndex", 2);
  },
  activated() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
    } else {
      this.getJJMTUserId(this.userInfo.Id);
    }
    this.$store.commit('changeNavbarIndex', 2);
  },
  methods: {
    ...mapActions(['setUserInfo']),
    async getMyInfo() {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: this.userInfo.Id
      });
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.userDetails = res.Data;
      }
      this.setUserInfo({userInfo: res.Data});
      sessionStorage.setItem("userInfo", JSON.stringify(res.Data));
    },
    async getOthersInfo(id) {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: id,
        UserAttentionId: this.userInfo.Id
      });
      this.userDetails = res.Data;
    },
    getJJMTUserId(userid) {
      this.$axios.get('/Api/Api/Web/Customer/GetJJMTUserId?userid=' + userid).then(res => {
        this.miniProgramShare(res.Data);
      })
    },
    miniProgramShare(userid) {
      wx.miniProgram.postMessage({
        data: {
          share: {
            title: '个人中心',
            imageUrl: process.env.VUE_APP_PERRONAL_IMG + userid,
            path: `/pages/personal/personal?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/xgPersonal')}&otherId=${userid}&sourceType=7`,
            contentId: ''
          }
        }
      })
    },
    getFollowState() {
      this.$axios.get('/Api/Api/Web/Customer/GetState?uaid=' + this.OthersInfo.Id).then(res => {
        this.followState = res.Data;
      })
    },
    getLive(id) {
      this.$axios.get('/Api/Api/Web/Customer/GetLive?uid=' + id).then(res => {
        this.liveDetailes = res.Data;
      })
    },
    getArticleList(id) {
      this.$axios.post('/Api/Api/Web/Customer/GetUserArt?userid=' + id).then(res => {
        this.articleList = res.Data;
      })
    },
    toMyFavorite() {
      this.BuriedPoint(1, "我的点赞", "", "/myFavorite");
      this.$router.push({
        path: 'myFavorite',
        query: {
          source: 'xg'
        }
      });
    },
    toMyCollection() {
      this.BuriedPoint(1, "我的收藏", "", "/myCollection");
      this.$router.push({
        path: 'myCollection',
        query: {
          source: 'xg'
        }
      });
    },
    toMyMeeting() {
      this.BuriedPoint(1, "我的预约", "", "/myMeeting");
      this.$router.push({
        path: 'myMeeting',
        query: {
          source: 'xg'
        }
      });
    },
    toBrowseRecords() {
      this.BuriedPoint(1, "历史记录", "", "/browseRecords");
      this.$router.push({
        path: 'browseRecords',
        query: {
          source: 'xg'
        }
      });
    },
    toFansFollowList(type) {
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.$router.push({
          path: 'FansFollowList',
          query: {
            type: type
          }
        });
      }
    },
    showFavorites() {
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.FavoritesPopup = true;
      }
    },
    follow() {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.OthersInfo.Id).then((res) => {
        this.followState = 1;
        this.userDetails.FansCount ++;
      });
    },
    unFollow() {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.OthersInfo.Id).then((res) => {
        this.followState = 0;
        this.userDetails.FansCount --;
      });
    },
    handlecollect(index) {
      let url = this.articleList[index].IsCollect ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.$axios.post(url, {
        ArticleId: this.articleList[index].Id,
        CustomerId: this.userInfo.Id,
        type: 2
      }).then((res) => {
        this.articleList[index].IsCollect = !this.articleList[index].IsCollect;
      });
    },
    handleLikes(index) {
      let url = this.articleList[index].IsLive ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.$axios.post(url, {
        ArticleId: this.articleList[index].Id,
        CustomerId: this.userInfo.Id,
        type: 3
      }).then((res) => {
        this.articleList[index].IsLive = !this.articleList[index].IsLive;
      });
    },
    toLive(url) {
      let loading = this.$toast.loading({
        message: '进入活动中...',
        forbidClick: true,
      });
      this.$axios.post('/Api/Api/Web/Live/UserLive', {
        uid: this.userInfo.Id,
        url: url
      }).then((res) => {
        loading.clear();
        window.location.href = res.Data;
      });
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            source: 'xg'
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            source: 'xg'
          }
        });
      }
    },
    toPersonalPoster() {
      this.$router.push({
        path: 'PersonalPoster',
        query: {
          type: 2
        }
      });
    },
    toLiveHome() {
      wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  padding: 20px 20px 20px;
  background-color: #F9F8F7;
  box-sizing: border-box;
  .goPersonal {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 15px;
    img {
      display: block;
      width: 10px;
      margin-right: 6px;
    }
  }
  .userInfoBox {
    position: relative;
    margin-top: 24px;
    z-index: 9;
    width: 100%;
    background-image: url("../../assets/images/mpbg1@2x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 8px;
    padding: 20px 20px 16px;
    box-sizing: border-box;
    color: #564C47;
    .userInfo {
      display: flex;
      margin-bottom: 16px;
      .touxiang {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
        margin-right: 12px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 3px;
        }
        .positionalName {
          font-size: 14px;
        }
      }
    }
    .hospital {
      display: flex;
      align-items: center;
      margin: 8px 0;
      img {
        display: block;
        width: 14px;
        margin-right: 8px;
        flex-shrink:0;
      }
      span {
        max-width: 85%;
        font-size: 14px;
        color: #564C47;
      }
    }
    .dataBox {
      display: flex;
      padding: 0 20px;
      margin-top: 10px;
      .dataItem {
        flex: 1;
        text-align: center;
        .dataNum {
          display: block;
          font-size: 15px;
          font-weight: bold;
          color: #030303;
        }
        .dataName {
          display: block;
          font-size: 12px;
          color: #564C47;
        }
      }
    }
    .followBtn {
      position: absolute;
      top: 21%;
      right: 20px;
      width: 70px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      border-radius: 30px;
      color: #FFFFFF;
      .plusIcon {
        font-size: 11px;
        margin-right: 2px;
      }
    }
    .follow {
      background: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
    }
    .unfollow {
      background: #A0A0A0;
    }
    .shareBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 12px;
      right: 8px;
      .shareIcon {
        width: 16px;
        margin-bottom: 3px;
      }
      span {
        color: #564C47;
        font-size: 10px;
      }
    }
    .customerServiceBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 65px;
      right: 8px;
      .customerServiceIcon {
        width: 18px;
        margin-bottom: 3px;
      }
      span {
        color: #564C47;
        font-size: 10px;
      }
    }
    .customerServiceBox_en {
      top: 12px;
    }
  }
  .menuBox {
    display: flex;
    margin-top: 20px;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    padding: 15px 5px;
    .menuItem {
      width: 25%;
      text-align: center;
      img {
        display: block;
        width: 50px;
        margin: 0 auto 7px;
      }
      span {
        font-size: 14px;
        color: #564C47;
      }
      .enMenuTitle {
        font-size: 13px !important;
      }
    }
  }
  .column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    margin-top: 20px;
    padding: 0 18px;
    img {
      display: block;
      width: 10px;
    }
    span {
      font-size: 14px;
      color: #564C47;
    }
  }
  .contentBox {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    margin-top: 20px;
    padding: 15px;
    .contentTitle {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #564C47;
      margin-bottom: 10px;
      img {
        display: block;
        margin-right: 6px;
      }
      .contentTitle_icon1 {
        width: 17px;
      }
      .contentTitle_icon2 {
        width: 16px;
      }
    }
    .notContent {
      min-height: 30px;
      border-radius: 8px;
      background-color: #F8F8FA;
      padding: 10px;
      .notContent_btn {
        width: 80px;
        height: 30px;
        border-radius: 30px;
        line-height: 30px;
        text-align: center;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: bold;
        background-image: linear-gradient(120deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
        margin: 0 auto;
      }
      .text {
        display: block;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        font-weight: bold;
        color: #7B7B7B;
      }
    }
    .liveBox {
      .liveCoverBox {
        position: relative;
        border-radius: 6px 6px 0 0;
        overflow: hidden;
        .liveCover {
          display: block;
          width: 100%;
        }
        .playIcon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          transform: translate(-20px, -20px);
        }
        .liveStatus {
          position: absolute;
          top: 0;
          left: 0;
          min-width: 50px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 8px;
          color: #FFFFFF;
          background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
          border-radius: 0 0 8px 0;
          padding: 0 4px;
          box-sizing: border-box;
        }
      }
      .liveTitle {
        font-size: 14px;
        line-height: 18px;
        margin-top: 10px;
      }
    }
    .articleList {
      .articleItem {
        display: flex;
        .articleCover {
          position: relative;
          width: 40%;
          border-radius: 6px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
          .sourceTag {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 50px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            font-size: 8px;
            color: #FFFFFF;
            background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
            border-radius: 0 0 8px 0;
            padding: 0 4px;
            box-sizing: border-box;
          }
        }
        .articleInfo {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 60%;
          padding-left: 8px;
          box-sizing: border-box;
          color: #564C47;
          .articleTitle {
            font-size: 14px;
            line-height: 18px;
          }
          .articleData {
            .operateBox {
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
            .operateItem {
              display: flex;
              align-items: center;
              font-size: 12px;
              margin-left: 10px;
            }
            .operateIcon {
              display: block;
              width: 12px;
              margin-right: 2px;
            }
            .watch {
              width: 13px;
            }
            .like {
              width: 11px;
            }
            .collect {
              width: 11px;
            }
          }
        }
      }
      .articleItem:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
  }
  .contactUs {
    font-size: 12px;
    line-height: 20px;
    color: #A0A0A0;
    text-align: center;
    margin-top: 20px;
    span {
      color: #EB1700;
    }
  }
  .unsubscribe {
    font-size: 12px;
    line-height: 20px;
    color: #A0A0A0;
    text-align: right;
    margin: 10px 0 0;
  }
}
.container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 110px;
  background-color: #EB1701;
  z-index: 1;
}
.CustomerServicePopup {
  width: 90%;
  border-radius: 14px;
  padding: 30px 0;
  box-sizing: border-box;
  text-align: center;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.customerServiceQRcode {
  span {
    font-size: 15px;
    font-weight: bold;
    color: transparent;
    background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
    background-clip: text;
    line-height: 22px;
  }
  .QRcodeBox {
    width: 100px;
    height: 100px;
    background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
    margin: 15px auto 0;
    padding: 5px;
    .QRcode {
      width: 100%;
      height: 100%;
      background-color: #FFFFFF;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.LogoutPopup {
  width: 90%;
  border-radius: 14px;
  padding: 20px 10px;
  box-sizing: border-box;
  text-align: center;
  overflow-y: visible;
  .warningIcon {
    display: block;
    width: 25px;
    margin: 0 auto 10px;
  }
  span {
    font-size: 14px;
    color: #606060;
    line-height: 22px;
  }
  .enLogoutTips {
    font-size: 12px !important;
  }
}
.FavoritesPopup {
  width: 84%;
  border-radius: 14px;
  text-align: center;
  overflow-y: visible;
  .FavoritesBox {
    .FavoritesTitle {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #606060;
      border-bottom: 1px solid #606060;
    }
    .FavoritesContent {
      padding: 30px 0;
      display: inline-block;
      .FavoritesItem {
        display: flex;
        align-items: center;
        font-size: 16px;
        margin-bottom: 30px;
        color: #606060;
        img {
          display: block;
          width: 25px;
          margin-right: 5px;
        }
        .title {
          display: inline-block;
          width: 120px;
          margin-right: 20px;
        }
        .enTitle {
          text-align: left;
          display: inline-block;
          width: 185px;
          font-size: 15px;
          margin-right: 20px;
        }
        .num {
          font-weight: bold;
        }
      }
      .FavoritesConfirm {
        width: 120px;
        height: 30px;
        line-height: 30px;
        background-image: url('../../assets/images/btn_bg1.png');
        background-size: 100% 100%;
        color: #FFFFFF;
        font-size: 14px;
        margin: 0 auto;
      }
    }
  }
}
</style>